import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-410">
      {visible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#111111] border-t border-[#2A2A2A] lg:hidden" data-id="element-411">
          <div className="flex items-center justify-between px-4 py-3 max-w-6xl mx-auto" data-id="element-412">
            <div className="flex flex-col" data-id="element-413">
              <span className="text-sm font-semibold text-[#F5F5F0]" data-id="element-414">
                CrownControl™
              </span>
              <span className="text-xs text-[#9CA3AF]" data-id="element-415">
                $497 · 180-Day Guarantee
              </span>
            </div>
            <button onClick={() => window.open('https://gogurlhoop.shop/checkouts/cn/hWN8w1extOgmGlbld4thOILK/en-us?_r=AQAByBvaKgWh4yuHmNpwXB8WBiSBVxx0XL7Jqt9qn0-QWv0&auto_redirect=false&edge_redirect=true&skip_shop_pay=true', '_blank')} className="
                bg-[#C8A04A] text-[#0A0A0A] font-bold text-sm
                px-6 py-2.5 rounded
                hover:bg-[#D4AF37] hover:shadow-[0_0_20px_rgba(200,160,74,0.3)]
                transition-all duration-300 cursor-pointer
                active:scale-[0.98]
              " data-id="element-416">
              Order Now
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}